export default __webpack_public_path__ + "static/rovo-menu-do-light-ff59233f79ce5d82a1bf5b34f614d61ff0805717992d0edc1f0eac1136e652c0.png";